function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M21.806 12.4066C22.0635 11.7954 22.0635 11.0946 21.806 10.4828C20.2838 6.86997 16.6847 4.53558 12.6371 4.53558C10.9371 4.53558 9.3165 4.94773 7.89577 5.69399L5.38674 3.22508C5.08159 2.92497 4.58859 2.92497 4.28344 3.22508C3.97844 3.52519 3.97844 4.01043 4.28344 4.31054L14.2123 14.0801L17.3752 17.1923L19.8868 19.6635C20.0396 19.8139 20.2394 19.8891 20.4391 19.8891C20.6388 19.8891 20.8385 19.8139 20.9907 19.6642C21.2958 19.3641 21.2958 18.8789 20.9907 18.5787L18.7179 16.3425C20.0576 15.3391 21.1351 13.9995 21.806 12.4066V12.4066ZM11.0572 8.80459C11.5198 8.53203 12.059 8.37389 12.6371 8.37389C14.3583 8.37389 15.7579 9.75117 15.7579 11.4447C15.7579 12.0134 15.5972 12.5439 15.3202 12.9992L11.0572 8.80459Z",
  fill: "#072E4B"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M12.1453 14.8017C10.4639 14.8017 9.09644 13.3548 9.09644 11.5759C9.09644 11.459 9.11779 11.3484 9.12924 11.2356L5.3366 7.22266C4.43112 8.15663 3.69101 9.28153 3.18872 10.5655C2.93709 11.2074 2.93709 11.9436 3.18872 12.5864C4.67493 16.3815 8.19095 18.8339 12.1453 18.8339C13.3778 18.8339 14.5676 18.5951 15.6667 18.1524L12.4669 14.767C12.3603 14.7791 12.2559 14.8017 12.1453 14.8017V14.8017Z",
  fill: "#072E4B"
});

var SvgHideeye = function SvgHideeye(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgHideeye, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/hideeye.2a99432b.svg";
export { ForwardRef as ReactComponent };